import { FormStore } from "@modules/formx";
import { observable, action } from "mobx";
import yup from "yup";

export type ReminderFormData = {
  date: Date;
  text: string;
  tags?: string[];
  assignedTeam?: string;
};

export class ReminderStore {
  @observable isLoading = false;
  @observable error = null;
  form = new FormStore<ReminderFormData>({
    onSubmit: () => this.submit(),
    debounceValidationMs: 250,
    schema: yup.object<ReminderFormData>({
      date: yup.date().nullable(true),
      text: yup.string().required("message required"),
      assignedTeam: yup.string().nullable(true)
    })
  });
  constructor(private onSubmit: (values: ReminderFormData) => Promise<any>) {}

  @action resetForm(values: ReminderFormData) {
    this.form.setValue("text", values.text);
    this.form.setValue("date", values.date);
    this.form.setValue("assignedTeam", values.assignedTeam);
  }

  private submit() {
    this.isLoading = true;
    return this.onSubmit(this.form.values)
      .then(() => console.info("form submit worked for data", this.form.values))
      .catch((err) => console.error("error", err))
      .finally(() => (this.isLoading = false));
  }
}
